import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('api', 'unidade-medida');

const unidadeMedidaActions = {
  gravar: { method: 'POST', url: `${basePath}` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}` },
  listarAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true` },
};

export default (resource) => resource(`${basePath}`, {}, unidadeMedidaActions);
